import clsx from "clsx"
import React from "react"
import { useController } from "react-hook-form"

interface Props extends React.InputHTMLAttributes<any> {
  control: any
  inputClassName?: string
  padding?: string
  label: string
}

export const HookFormInput = ({
  control,
  name,
  className,
  placeholder,
  label,
  ...props
}: Props) => {
  const { field, fieldState } = useController({ name, control })
  const { error } = fieldState
  const errorText = error?.message

  return (
    <div className={clsx("material_input relative", className ?? "")}>
      <input
        placeholder={placeholder}
        {...field}
        {...props}
        id={name}
        className={clsx(errorText && "error", "sm-only:text-sm")}
      />
      <label className="label" htmlFor={name}>
        <div className="text">{label}</div>
      </label>
      <small className="text-red absolute left-0 bottom-[-18px]">{errorText}</small>
    </div>
  )
}
